import Head from 'next/head';
import { DefaultSeo } from 'next-seo';

export default function StructuredData() {
  return (
    <>
      <DefaultSeo
      // Define default SEO configuration here
      />
      <Head>
        <title>
          eighteen yards | our purpose
        </title>
        <meta
          name="description"
          content="At eighteen yards, we help sports-related businesses understand and implement performance-driven sports digital marketing strategies. Learn about us."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "eighteen yards | Our Purpose",
              "description": "At eighteen yards, we help sports-related businesses understand and implement performance-driven sports digital marketing strategies. Learn about us.",
              "url": "https://eighteenyards.com/purpose",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://eighteenyards.com/purpose"
              },
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://eighteenyards.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Purpose",
                    "item": "https://eighteenyards.com/purpose"
                  }
                ]
              },
              "headline": "Our Purpose in Sports Digital Marketing",
              "publisher": {
                "@type": "Organization",
                "name": "eighteen yards",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://example.com/logo.png",
                  "width": 600,
                  "height": 60
                }
              },
              "image": {
                "@type": "ImageObject",
                "url": "https://example.com/image.jpg",
                "width": 1200,
                "height": 630
              }
            }),
          }}
        />
      </Head>
    </>
  )
}
